<template>
  <div class="order">
    <div class="p-title">点位投放</div>
    <div class="p-main">
      <div class="put_tabs" v-show="!isShowConfirm">
        <span
          v-for="{ code, title } in tabItems"
          :class="['put_tab_pane', {'act': code === curTab}]"
          :key="code"
          @click="tabSelect(code)">
          {{ title }}
        </span>
      </div>
      <PutOrderExcelImport v-if="renderFlag" :isExport="isExport" :importType="importType" @showConfirm="confirmFn"></PutOrderExcelImport>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

/*
  小屏相关须带有 smallSn 字样 其他地方可以 获取store order coditionSearchTypeName.toLowerCase indexOf 'smallsn' > -1 判断
  导入相关须带有 Import 字样 其他地方可以 获取store order coditionSearchTypeName.toLowerCase indexOf 'import' > -1 判断
*/
const allTab = [{
  title: '条件筛选',
  code: 'putOrder'
}, {
  title: '导入小区',
  code: 'communityImport'
}, {
  title: '导入点位',
  code: 'deviceImport'
}, {
  title: '小屏投放',
  code: 'smallSn'
}, {
  title: '小屏导入点位',
  code: 'smallSnDeviceImport'
}]

const actionUidTab = { // 演示专用 id 相关  tab 展示控制
  15595: [allTab[0]],
  2002609: [allTab[0]],
  2000831: [allTab[3]],
  2000409: allTab.slice(0, 3), // 20220525——上海再灵用户(18967830077)不展示“小屏投放”“小屏导入”tab
  2003128: allTab.slice(0, 3), // 20220607——上海再灵用户隐藏“小屏投放”tab
  15127: allTab.slice(0, 3), // 20220823——特殊用户隐藏“小屏投放”tab

  // 20221020——河南新再灵用户不展示"小屏"相关tab
  2003208: allTab.slice(0, 3),
  2003209: allTab.slice(0, 3),
  // 20230113——上海新再灵用户不展示"小屏"相关tab
  2003233: allTab.slice(0, 3),
  14896: allTab.slice(0, 3),
  15437: allTab.slice(0, 3),
  14889: allTab.slice(0, 3),
  14493: allTab.slice(0, 3)
}

export default {
  name: 'PutOrder',
  components: { PutOrderExcelImport: () => import('./PutOrderExcelImport') },
  data () {
    return {
      curTab: '',
      isShowConfirm: false,
      renderFlag: true
    }
  },
  computed: {
    ...mapState({
      tabItems: s => {
        return s ? s.customer.putOrderTabs : []
      }
    }),
    isExport () {
      return this.curTab.indexOf('Import') > 0
    },
    importType () {
      return this.curTab.replace('Import', '')
    }
  },
  // watch: {
  //   '$store.state.customer.userInfo': {
  //     immediate: true,
  //     handler (v) {
  //       if (!v) return
  //       if (actionUidTab[v.id]) return this.tabItems = actionUidTab[v.id]
  //       else this.tabItems = allTab
  //     }
  //   }
  // },
  beforeDestroy () {
    window.$listCopy = null
    delete window.$listCopy
    this.$store.commit('order/setCoditionSearchType', '') // 还原搜索类型
    this.$store.commit('order/setPayWay', '')
  },
  created () {
    this.$store.dispatch('getTimeRanges') // 购买时间段
    this.$store.dispatch('getDictItemList', 'NEW_NO_PLAY_LABLE') // 预加载新禁播标签
    this.$nextTick(() => {
      const initTab = this.tabItems[0] && this.tabItems[0].code
      if (initTab) {
        this.tabSelect(initTab)
      }
    })
  },
  methods: {
    tabSelect (tabName) {
      if (tabName === this.curTab) return
      this.curTab = tabName
      this.$store.commit('order/setCoditionSearchType', tabName)

      this.renderFlag = false
      this.$nextTick(() => {
        this.renderFlag = true
      })
    },
    confirmFn(v) {
      this.isShowConfirm = v
    }
  }
}
</script>

<style lang="scss" scoped>
.put_tabs {
  height: 50px;
  padding: 0 10px;
  background-color: #f5f5f5;
  box-shadow: 0 -1px 0 0 #d4d4d4 inset;
}
.put_tab_pane {
  display: inline-block;
  padding: 9px 28px;
  margin-top: 8px;
  margin-left: 10px;
  color: #666666;
  font-size: 16px;
  line-height: 22px;
  background-color: #F5F5F5;
  border: 1px solid #D4D4D4;
  border-radius: 4px 4px 0 0;
  cursor: pointer;
  &:hover {
    color: #000;
  }
  &.act {
    color: #282729;
    background-color: #FFFFFF;
    border-bottom-color: #fff;
    font-weight: bolder;
  }
}
</style>
